<app-left-menu></app-left-menu>
<div id="main-container">

    <app-header [title]="title" [showAddAvailabilityButton]=true></app-header>

    <div class="content-header" style="margin-top: 70px;">
        <div class="pharse"
        style="text-align: center;padding-bottom: 10px;font-style:italic">
        {{'Availability.Pharse'|translate}}</div>
        <ul class="nav nav-tabs content" role="tablist">
            <li role="presentation" class="active"><a href="#currentAvailability" role="tab" data-toggle="tab"
                    aria-expanded="true">{{'Common.Headers.CurrentAvailability' | translate}}
                </a>
            </li>
            <li role="presentation"><a href="#pastAvailability" role="tab" data-toggle="tab"
                    aria-expanded="false">{{'Common.Headers.PastAvailability' | translate}}</a>
            </li>
        </ul>
    </div>
    <div class="page-content">

        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="currentAvailability">
               
                    <!--<div id="{{(year.FullDate | date:'MM') +'_'+(year.FullDate | date:'y')}}"></div>-->

                    <table *ngIf="current?.length>0" class="table table-bordered" id="table">
                        <thead>
                            <tr>
                                <th> {{'Availability.Table.Header.FromDate' | translate}}</th>
                                <th> {{'Availability.Table.Header.ToDate' | translate}}</th>
                                <th> {{'Availability.Table.Header.Notes'| translate}}</th>
                                <th style="text-align: center;"> {{'Common.Action'| translate}}</th>

                            </tr>
                        </thead>
                        <tbody>

                            <tr [class.alternate]="i%2!=0" *ngFor="let item of current; index as i;">

                                <td style="width: 60px;">{{item.FromDate | date:'MM/dd/yyyy'}}</td>
                                <td style="width: 60px;">{{item.ToDate | date:'MM/dd/yyyy'}}</td>
                                <td >{{item.Notes}}</td>
                                <td style="width: 50px;text-align: center;"><a [routerLink]="['/availability/edit',item.ProviderStatusId]" routerLinkActive="router-link-active" class="icon edit round"  href="javascript:void(0)"></a></td>
                            </tr>
                        </tbody>
                    </table>                
                <div class="not-found" *ngIf="current?.length==''">{{'Availability.NoRecord.Current'|translate}}
                </div>

            </div>
            <div role="tabpanel" class="tab-pane " id="pastAvailability">
               
                <!--<div id="{{(year.FullDate | date:'MM') +'_'+(year.FullDate | date:'y')}}"></div>-->

                <table *ngIf="past?.length>0" class="table table-bordered" id="table">
                    <thead>
                        <tr>
                            <th>{{'Availability.Table.Header.FromDate' | translate}}</th>
                            <th> {{'Availability.Table.Header.ToDate' | translate}}</th>
                            <th> {{'Availability.Table.Header.Notes'| translate}}</th>
                            <th style="text-align: center"> {{'Common.Action'| translate}}</th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr [class.alternate]="i%2!=0" *ngFor="let item of past; index as i;">

                            <td style="width: 60px;">{{item.FromDate | date:'MM/dd/yyyy'}}</td>
                            <td style="width: 60px;">{{item.ToDate | date:'MM/dd/yyyy'}}</td>
                            <td >{{item.Notes}}</td>
                            <td style="width: 50px;text-align: center;"><a [routerLink]="['/availability/edit',item.ProviderStatusId]" routerLinkActive="router-link-active" class="icon edit round" href="javascript:void(0)"></a></td>
                        </tr>
                    </tbody>
                </table>                
            <div class="not-found" *ngIf="past?.length==''">{{'Availability.NoRecord.Past'|translate}}
            </div>

        </div>
        </div>

    </div>

</div>